<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          persistent
        >
          <v-card class="" rounded="0">
            <v-toolbar flat color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("User Details")
              }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
              <v-card-text class="black--text pt-10">
                <v-row>
                    <v-col md="6" sm="12" class="py-0">
                        <label 
                            for="name"
                            >{{ $t("name") }}</label>
                        <v-text-field
                            v-model="editedUser.name"
                            :placeholder="$t('name')"
                            outlined
                            dense
                            readonly
                            hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="12" class="py-0">
                        <label for="email">
                            {{ $t("emailAddress") }}
                        </label>
                        <v-text-field
                            v-model="editedUser.email"
                            :placeholder="$t('emailAddress')"
                            outlined
                            dense
                            readonly
                        ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="12" class="py-0">
                        <label for="mobile">
                        {{ $t("mobileNum") }}
                        </label>
                        <v-text-field
                            v-model="editedUser.mobile"
                            :placeholder="$t('mobileNum')"
                            outlined
                            dense
                            readonly
                        ></v-text-field>
                    </v-col>
                    <v-col md="6" sm="12" class="py-0">
                        <label for="department">
                            {{ $t("department") }}
                        </label>
                        <v-select
                            v-model="editedUser.department"
                            :items="departmentList"
                            item-text="name"
                            item-value="name"
                            outlined
                            dense
                            :placeholder="$t('farm.selectDept')"
                            readonly
                        ></v-select>
                    </v-col>
                    <v-col md="6" sm="12" class="py-0">
                        <label for="role">
                            {{ $t("role") }}
                        </label>
                        <v-select
                            v-model="editedUser.role"
                            :items="rolesList"
                            item-text="name"
                            item-value="name"
                            outlined
                            dense
                            readonly
                            :placeholder="$t('farm.selectRole')"
                        ></v-select>
                    </v-col>
                    <v-col md="6" sm="12" class="py-0">
                        <label for="status">
                            {{ $t("Status") }}
                        </label>
                        <v-select
                            v-model="editedUser.status"
                            :items="[{ id: 1, name: 'Active'}, { id: 0, name: 'Deactived'}]"
                            item-text="name"
                            item-value="id"
                            outlined
                            dense
                            readonly
                            :placeholder="$t('farm.selectRole')"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-card-actions class="mt-10 px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="closeModal()"
                    class="mr-2"
                    outlined
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                  >
                    {{ $t("close") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin";

export default {
  created() {
    let codes = this.editedUser.mobile.split(" ")
    if(codes && codes.length == 2){
      this.countryCode = Number(codes[0])
      this.userMobile = codes[1]
    }


    const fetchData = async () => {
      this.startLoading();
      this.departmentList = await this.getDepartments();
      this.deptNameToId = {};
      this.departmentList.forEach(e => {
        this.deptNameToId[e.name] = e.departmentNumber;
      });
      if (this.editedUser.department)
        this.getRoles(this.deptNameToId[this.editedUser.department]);
      this.stopLoading();
    };
    fetchData();
  },
  computed: {
    dialog() {
      return this.dialogU;
    },
  },
  data() {
    return {
        deptNameToId: {},
        departmentList: [],
        rolesList: [],
        roleLoading: false,
        fieldType: { text: "text" },
        error: false,
        editedUser: { ...this.user },
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeUpdateUser");
    },

    async getRoles() {
      this.rolesList = [];
      this.roleLoading = true;
      this.rolesList = await this.getRolesList(
        this.deptNameToId[this.editedUser.department]
      );
      this.roleLoading = false;
    },
  },
  props: {
    dialogU: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  mixins: [loadingMixin, generalMixin, PermissionsMixin],
};
</script>

<style >

</style>
